import type { RequestVersionDelta } from '../types/RequestVersion';

const CHANNEL_COMMERCIAL_FIELD_KEYS = new Set([
  'oppOpportunityId',
  'oppQuoteNumber',
]);

export const shouldHideVersionHistoryCommercialFields = (
  roles: readonly string[],
): boolean => {
  const roleSet = new Set(roles);
  return (
    (roleSet.has('External Requestor') &&
      !roleSet.has('External Requestor LVO')) ||
    (roleSet.has('Partner Contributor') &&
      !roleSet.has('Partner Contributor LVO'))
  );
};

const maskRowValue = (value: unknown): unknown => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return value;
  }
  const visible = { ...(value as Record<string, unknown>) };
  CHANNEL_COMMERCIAL_FIELD_KEYS.forEach(key => delete visible[key]);
  return visible;
};

/**
 * Client-side defense in depth for #1543. The API remains the security boundary; this keeps
 * Revision History from rendering channel-sensitive values if an old/misconfigured API leaks
 * them in a field delta or whole-row delta.
 */
export const maskVersionHistoryDeltasForRoles = (
  deltas: RequestVersionDelta[],
  roles: readonly string[],
): RequestVersionDelta[] => {
  if (!shouldHideVersionHistoryCommercialFields(roles)) {
    return deltas;
  }

  return deltas
    .filter(
      delta => !delta.field || !CHANNEL_COMMERCIAL_FIELD_KEYS.has(delta.field),
    )
    .map(delta => ({
      ...delta,
      oldValue: maskRowValue(delta.oldValue),
      newValue: maskRowValue(delta.newValue),
    }));
};
